
import axios from  'axios';

class Cache {
  constructor (options) {
    options = options || {};
    this.data = null;
    this.callbacks = [];
    if (options.url) {
      let url = options.url;
      this.remote = async (opts) => {
        this.loading = true;
        try {
          let response =  await axios(Object.assign({
            url : url
          }, opts));
          this.data = response.data.result;
          let i = 0, fn = null ;
          while(fn = this.callbacks[i++]) {
            fn(null, this.data);
          }
        } catch (e) {
          let i = 0, fn = null ;
          while(fn = this.callbacks[i++]) {
            fn(e);
          }
        } finally {
          this.loading = false;
        }
      };
    } else {
      this.data = options.data;    
    }
  }

  getData(opts) {
    return new Promise((resolve, reject) => {
      if(this.remote && !this.data) {
        let fn = (err, data) => {
          if(err) {
            reject(err);
          } else {
            resolve(data);
          }
        }
        this.callbacks.push(fn);
        if (!this.loading) {
          this.remote(opts);
        }
        return;
      }
      resolve(this.data);
    });
  }
}

export default Cache;
